<header class="flex background-gradient py-5">
  <div class="mx-auto">
    <img src="assets/img/motorola-logo.svg" alt="Motorola Branding" class="motorola-branding">
  </div>
</header>

<main class="home-body m-auto">
  <div class="mx-5">
    <img src="assets/img/moto-ai-beta.svg" alt="Moto AI Beta">
    <p class="home-introduction font-bold" [translate]="'app.home.introduction'"></p>
  </div>
  <div class="home-form">
    <form [formGroup]="motoAiForm" (ngSubmit)="onSubmit()">
      <span class="p-float-label mx-5">
        <input id="name-input" class="form-input pl-3" type="text" pInputText formControlName="name">
        <label for="name-input"
               class="form-input-label">{{ 'app.home.fullNamePlaceholder' | translate }}</label>
      </span>

      <div class="mt-3 mx-5">
        <span class="p-float-label">
          <input id="email-input" class="form-input pl-3" [ngClass]="{'ng-invalid': emailError}" type="text" pInputText
                 formControlName="email" #inputElement>
          <label for="email-input" class="form-input-label">{{ 'app.home.emailPlaceholder' | translate }}</label>
        </span>
        <p *ngIf="emailError" class="error-message text-left pl-3" [translate]="'app.home.invalidEmail'"></p>
      </div>

      <div class="pt-5 mx-5 grid">
        <div class="flex">
          <p-checkbox [binary]="true"
                      id="requirementsLabel"
                      formControlName="isRequirementsConfirmed"
                      class="px-4 checkbox-confirmation"
          ></p-checkbox>
          <label class="text-left checkbox-confirmation-label"
                 for="requirementsLabel"
                 [innerHTML]="'app.home.requirementsLabel' | translate"
          ></label>
        </div>
      </div>

      <footer class="home-footer">
        <button pButton
                [label]="'app.home.tryMotoAi' | translate"
                routerLink="/download"
                class="button home-submit-button"
                type="submit"
                [disabled]="motoAiForm.invalid"
        ></button>
        <button pButton
                type="button"
                (click)="redirectToLearnMore()"
                [label]="'app.home.learnMore' | translate"
                class="p-button-link learn-more-button w-full"
        ></button>
      </footer>
    </form>
  </div>
</main>
